import { createIcon } from '@chakra-ui/react';

export const CreditCardOutlineIcon = createIcon({
  displayName: 'CreditCardOutlineIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
        <path
          d="M1 4.25391H11"
          stroke="#6E6789"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 8.25391H4"
          stroke="#6E6789"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 8.25391H7.25"
          stroke="#6E6789"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.22 1.75391H8.775C10.555 1.75391 11 2.19391 11 3.94891V8.05391C11 9.80891 10.555 10.2489 8.78 10.2489H3.22C1.445 10.2539 1 9.81391 1 8.05891V3.94891C1 2.19391 1.445 1.75391 3.22 1.75391Z"
          stroke="#6E6789"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
